// src/pages/Profile.js
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
// Revert this line back to a default import
import ProfileForm from '../components/profile/ProfileForm'; 
import { auth, db } from '../services/firebase';
// Or just log it in the console:
console.log('Current user:', auth.currentUser);
console.log('User ID:', auth.currentUser?.uid);
console.log('User email:', auth.currentUser?.email);

function ProfilePage() {
  const { jeweller } = useAuth();
  return <ProfileForm jeweller={jeweller} />;
}

export default ProfilePage;